module.exports = __webpack_public_path__ + "img/visa.fc297d1c.png";